import { computed, ref } from 'vue';
import { AppSettingService } from '@/service/AppSettingService';

const appSettingService = new AppSettingService();
const fallbackTitle = import.meta.env.VITE_FALLBACK_SITE_TITLE || 'فروشگاه اینترنتی طلا و جواهرات مهر';
const siteSettings = ref({
  site_title: fallbackTitle
});
const loadingSiteSettings = ref(false);
let loadPromise = null;

const siteTitle = computed(() => siteSettings.value.site_title || fallbackTitle);

const syncDocumentTitle = () => {
  if (typeof document !== 'undefined') {
    document.title = siteTitle.value;
  }
};

const loadSiteSettings = async () => {
  if (loadPromise) {
    return loadPromise;
  }

  loadingSiteSettings.value = true;
  loadPromise = appSettingService
    .getPublicSettings()
    .then(({ data }) => {
      siteSettings.value = { ...siteSettings.value, ...(data?.data || {}) };
      syncDocumentTitle();
    })
    .catch(() => {
      syncDocumentTitle();
    })
    .finally(() => {
      loadingSiteSettings.value = false;
    });

  return loadPromise;
};

export function useSiteSettings() {
  syncDocumentTitle();

  return {
    siteSettings,
    siteTitle,
    loadSiteSettings,
    loadingSiteSettings,
    syncDocumentTitle
  };
}
